import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiService } from '../core/api.service';
import { endPoints } from '../core/Apis/apiEndpoints';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {
  creationForm: FormGroup;
  constructor(private userService:ServiceService,
    private formBuilder: FormBuilder,
    private apiService: ApiService
  ) {
    this.creationForm = this.formBuilder.group({
      workin_time: [''],
      workout_time: [''],
      is_department_specific: [false],
      is_customer_location_enabled: [false],
      is_location_restricted: [false],
      weekly_working_days:[[]],
      factory_department_id: [''],
      is_visit_location_restricted : [false],    });
   }

  //searchEmployeeUrl='http://192.241.151.66:5000/viewEmployees?employee_name='
  //createUrl="http://192.241.151.66:5000/userCreation"
  employee:any=[];
  employee_id=""
  searchEmployee:string='';
  isShownEmployee=false
  username=""
  password=""
  C_password=""
  doesntMatch=""
  Search_employee=""
  emp_type=""
  alert=""
  isShown: boolean = false;
  // Password visibility toggles
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  // Toast message properties
  toastMessage: string = '';
  toastType: 'success' | 'error' = 'success';
  toastTimeout: any;
  data={
    username:"",
    password:"",
    conformpassword:"",
    usertype:"",
    employee_id:"",
    employee_name:""
  }
  data1={
    user_id:"",
    username:"",
    password:"",
    user_type:"",
    workin_time : '',
    workout_time : '',
    is_department_specific : false,
    is_location_restricted : false,
    is_customer_location_enabled:false,
    weekly_working_days : [],
    is_visit_location_restricted : false
  }
  //for showing notifivation
notification(){
  this.isShown = !this.isShown;
}
  // Toggle password visibility
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  // Toggle confirm password visibility
  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  // Show toast message
  showToast(type: 'success' | 'error', message: string) {
    // Clear any existing timeout
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }
    
    this.toastType = type;
    this.toastMessage = message;
    
    // Set timeout to 15 seconds for better visibility
    this.toastTimeout = setTimeout(() => {
      this.closeToast();
    }, 5000);
  }

  // Close toast message
  closeToast() {
    this.toastMessage = '';
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }
  }
  //-------------function for search--------------------
SearchEmployee(){
  console.log("employee=",this.data.employee_name)
  if(this.data.employee_name!='')
  {
  this.isShownEmployee=true;
  }
  this.searchEmployee=this.data.employee_name
  this.userService.SearchEmployee(this.searchEmployee).subscribe((res)=>{
  this.employee=res.data
 
  })
}
//---------function for getting searched employee id---------------
getEmployeeId(value1:any,value2:any){
     
     this.isShownEmployee=false
     //this.searchEmployee=value2
     //this.employee_id=value1
     this.data.employee_name=value2
     this.data.employee_id=value1
     console.log("search result",this.data.employee_id)
}
//---------check value changes in the text box----
valuechange1(newValue1: any) {
  this.data.username=newValue1
  this.username=""
}
valuechange2(newValue1: any) {
  this.data.password=newValue1
  this.password=""
  // Check password mismatch when password changes
  if (this.data.conformpassword && this.data.password !== this.data.conformpassword) {
    this.doesntMatch = "Passwords don't match";
  } else {
    this.doesntMatch = "";
  }
}
valuechange3(newValue1: any) {
  this.data.conformpassword=newValue1
  this.C_password=""
  // Check password mismatch when confirm password changes
  if (this.data.password && this.data.password !== this.data.conformpassword) {
    this.doesntMatch = "Passwords don't match";
  } else {
    this.doesntMatch = "";
  }
}
valuechange4(newValue1: any) {
  this.data.employee_name=newValue1
  this.Search_employee=""
}
valuechange5(newValue1: any) {
  this.data.usertype=newValue1
  this.emp_type=""
}
 //--------function for shown the alert----------
 shown(){
  this.isShown=false
}
Create(){

  console.log("Employee=",this.data.employee_name)
  if(this.data.username==""){
  this.username="enter user name"
 }
 if(this.data.password==""){
  this.password="enter password"
 }
 if(this.data.usertype==""){
  this.emp_type="select user type"
 }
 
 if(this.data.conformpassword==""){
  this.C_password="enter conform password"
  this.doesntMatch=""
 }  
 if(this.data.employee_name==""){
  console.log("Employee=",this.data.employee_name)
  this.Search_employee="select the employee name"
 }

 if(this.data.password!= this.data.conformpassword)
 {
  this.doesntMatch="doesn't match"
  return
 }
 if(this.data.password==this.data.conformpassword)
 {
  this.notification();
 }
 this.data1.user_id=this.data.employee_id
 this.data1.username=this.data.username
 this.data1.user_type=this.data.usertype
 this.data1.password=this.data.password
 console.log("id=",this.data1.user_id)
 console.log("name=",this.data1.username)
 console.log("type=",this.data1.user_type)
 console.log("password=",this.data1.password)
 this.userService.userCreation(this.data1).subscribe((res) => {
 this.alert=res.message;
 // Show toast message instead of alert
 if (res.success) {
   this.showToast('success', res.message);
   // Reset form after successful creation
   this.data = {
     username: "",
     password: "",
     conformpassword: "",
     usertype: "",
     employee_id: "",
     employee_name: ""
   };
 } else {
   // Check if user already exists
   if (res.message && res.message.toLowerCase().includes('already')) {
     this.showToast('error', 'User Already Exists! Please choose a different username.');
   } else {
     this.showToast('error', res.message || 'Failed to create user. Please try again.');
   }
 }
}, (error) => {
 // Handle network or server errors
 this.showToast('error', 'An error occurred. Please try again later.');
 console.error('Error creating user:', error);
})
 }

  ngOnInit(): void {
    this.getUsertype()
    this.fetchFactoryDepartment()
  }
  userTypedropdown:any
  getUsertype(){
    this.userService.usertypeDropdown().subscribe((res) => {
      this.userTypedropdown = res.data
    })
  }

  weeKDays = [
    {
      week: 'Sunday',
      value: 1,
      checked:false
    },
    {
      week: 'Monday',
      value: 2,
      checked:false
    },
    {
      week: 'Tuesday',
      value: 3,
      checked:false
    },
    {
      week: 'Wednesday',
      value: 4,
      checked:false
    },
    {
      week: 'Thursday',
      value: 5,
      checked:false
    },
    {
      week: 'Friday',
      value: 6,
      checked:false
    },
    {
      week: 'Saturday',
      value: 7,
      checked:false
    },
  ];
  selectedWeek: any = [];
  weekSelected(value: any) {
    if (this.selectedWeek.includes(value)) {
      const index = this.selectedWeek.indexOf(value);
      if (index > -1) {
        this.selectedWeek.splice(index, 1);
      }
    } else {
      this.selectedWeek.push(value);
    }
    console.log(this.selectedWeek);
  }

  attendanceData(){
    this.data1.workin_time = this.creationForm.controls['workin_time'].value
    this.data1.workout_time = this.creationForm.controls['workout_time'].value
    this.data1.is_department_specific = this.creationForm.controls['is_department_specific'].value
    this.data1.is_location_restricted = this.creationForm.controls['is_location_restricted'].value
    this.data1.is_customer_location_enabled = this.creationForm.controls['is_customer_location_enabled'].value
    this.data1.weekly_working_days = this.selectedWeek
    this.data1.is_visit_location_restricted = this.creationForm.controls['is_visit_location_restricted'].value
    console.log(this.creationForm.value);
    console.log(this.data1);
    
  }

  factoryDepartmentdropdown : any = []
  fetchFactoryDepartment(){
    this.apiService.get(endPoints.factoryDepartment ,'/api/dropdown').subscribe({
      next : (value) => {
    this.factoryDepartmentdropdown = value.data    
  },
      error : (err) => {
        alert("error in fetching factory department")
        console.error(err);
      }
    })
  }
  
  

}